module.exports = __webpack_public_path__ + "img/Banner-WritingHomeModelConcept-dwnszd.7cb6bf1c.jpg";